import { useFrame } from '@react-three/fiber';
import { MutableRefObject } from 'react';
import * as THREE from 'three';

export function useModelRotation(
  ref: MutableRefObject<THREE.Object3D | null>,
  enabled: boolean,
  speed = 1,
) {
  useFrame((_, delta) => {
    if (!enabled || !ref.current) return;
    ref.current.rotation.y += delta * speed;
  });
}
